import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useBranding } from '../theme/brandingContext';

const LandingPage = () => {
  const { branding } = useBranding();
  const companyName = branding?.companyName || 'United Fidelity Funding';

  return (
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', py: { xs: 4, md: 8 } }}>
      <Container maxWidth="md">
        <Stack spacing={1} sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h1" component="h1">
            Welcome to {companyName}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Start a new mortgage application or check the status of an existing loan.
          </Typography>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2.5}
          justifyContent="center"
        >
          <Card sx={{ flex: 1, maxWidth: { sm: 340 } }}>
            <CardContent sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <DescriptionOutlinedIcon />
                </Box>
                <Box>
                  <Typography variant="h3" component="h2" sx={{ mb: 0.5 }}>
                    Apply now
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Complete a short online application. Your progress is saved as you go.
                  </Typography>
                </Box>
                <Button
                  component={RouterLink}
                  to="/apply"
                  variant="contained"
                  color="primary"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ alignSelf: 'flex-start' }}
                >
                  Start application
                </Button>
              </Stack>
            </CardContent>
          </Card>

          <Card sx={{ flex: 1, maxWidth: { sm: 340 } }}>
            <CardContent sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    bgcolor: 'secondary.main',
                    color: 'secondary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SearchOutlinedIcon />
                </Box>
                <Box>
                  <Typography variant="h3" component="h2" sx={{ mb: 0.5 }}>
                    Check loan status
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Look up your loan with your loan number and ZIP or phone last four.
                  </Typography>
                </Box>
                <Button
                  component={RouterLink}
                  to="/status"
                  variant="outlined"
                  color="primary"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ alignSelf: 'flex-start' }}
                >
                  Check status
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default LandingPage;
